'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HtmlParser = require('./HtmlParser');

var _HtmlParser2 = _interopRequireDefault(_HtmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HtmlParser2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-html-parser/lib/index.js
// module id = 694
// module chunks = 0